<!--

 * @Author: zuishuanicx 1342142818@qq.com

 * @Date: 2022-11-25 15:13:33

 * @LastEditors: zuishuanicx 1342142818@qq.com

 * @LastEditTime: 2023-01-09 20:04:29

 * @FilePath: \dzCloud\src\projects\tiktok\pages\materialCenter\components\UploadPictures.vue

 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE

-->

<template>
    <el-dialog
        title="图片上传"
        :visible.sync="dialogVisible"
        width="1300px"
        :before-close="handleClose"
        :close-on-click-modal="false"
        append-to-body
    >
        <div class="dz-flex status">
            <div :class="typeStatus == '0' ? 'status-active1' : ''" @click="handleClick('0')">本地上传</div>

            <div :class="typeStatus == '1' ? 'status-active1' : ''" @click="handleClick('1')">素材中心</div>
        </div>

        <div v-show="typeStatus === '0'">
            <div class="dfc title pb20 mt20">
                <span class="label-title">上级至</span>

                <el-cascader
                    :options="options"
                    clearable
                    style="width: 300px"
                    size="mini"
                    v-model="directoryId"
                    :props="{
                        value: 'folderId',

                        label: 'name',

                        children: 'children',

                        checkStrictly: true,

                        emitPath: false,
                    }"
                ></el-cascader>
            </div>

            <el-upload
                ref="upload1"
                action="#"
                multiple
                :before-upload="(e) => beforeUpload(e)"
                :http-request="uploadSectionFile"
                accept="image/png,image/jpg,image/jpeg"
                :show-file-list="false"
                drag
                class="upload-demo mb10 upload-box"
            >
                <i class="el-icon-upload"></i>

                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>

                <div class="el-upload__tip" slot="tip">
                    {{ textData.text }}
                </div>
            </el-upload>

            <div class="img-box">
                <div v-for="(v, index) in urls" :key="index" class="mb20">
                    <!-- <img :src="v.url" class="img-box" /> -->

                    <div class="dfjbet">
                        <div class="dfc">
                            <i class="el-icon-picture-outline mr10"></i>

                            <p class="mr30">{{ v.name }}</p>
                        </div>

                        <i class="el-icon-delete curp" @click="del(index)"></i>
                    </div>
                </div>
            </div>

            <p>({{ urls.length }}/{{ textData.max }})</p>
        </div>

        <!-- 素材中心 -->

        <div v-show="typeStatus === '1'">
            <material-Tree :typeStatus="typeStatus" @confirmSuccess="confirmSuccess" :textData="textData" />
        </div>

        <span slot="footer" class="dialog-footer" v-if="typeStatus == '0'">
            <el-button @click="dialogVisible = false">取 消</el-button>

            <el-button type="primary" :loading="loading" @click="determine">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import MaterialTree from './MaterialTree';
import axios from 'axios';
var base = '';
var ossImg = '';
if (process.env.NODE_ENV === 'development') {
    base = 'https://test-api.fjdaze.com/';
    ossImg = 'http://test-oss.fjdaze.com/';
} else if (location.host.indexOf('127.0.0.1') !== -1) {
    base = 'https://test-api.fjdaze.com/';
    ossImg = 'http://test-oss.fjdaze.com/';
} else if (location.host.indexOf('192.168.0') !== -1) {
    base = 'https://test-api.fjdaze.com/';
    ossImg = 'http://test-oss.fjdaze.com/';
} else if (location.host.indexOf('test-douyin.dazeyun.com') > -1) {
    base = 'https://test-api.fjdaze.com/';
    ossImg = 'http://test-oss.fjdaze.com/';
} else {
    base = 'https://api.fjdaze.com/';
    ossImg = 'http://oss.fjdaze.com/';
}
export default {
    components: {
        MaterialTree,
    },
    data() {
        return {
            dialogVisible: false,
            directoryId: '',
            options: [],
            urls: [],
            loading: false,
            textData: {},
            typeStatus: '0',
            leftLoading: false,
            searchTime: 0,
        };
    },
    methods: {
        show(data) {
            this.textData = data;
            this.searchTime = 0;
            this.urls = [];
            this.options = [];
            this.directoryId = '';
            this.getSearch();
            this.dialogVisible = true;
        },
        getSearch() {
            let ajaxData = {
                orderBy: 0,
                pageNum: 1,
                pageSize: 100,
                operateStatus: [1],
                parentFolderId: '0',
            };
            this.$ajax.post('/api/tiktok/Material/SearchFolder', ajaxData).then((res) => {
                this.leftLoading = false;
                if (res.result == []) {
                    res.result = [];
                }
                let data = res.result.folderInfoListEx.map((v) => {
                    return {
                        parentFolderId: v.parentFolderId,
                        folderId: v.folderId,
                        name: v.name,
                        createTime: v.createTime,
                        deleteTime: v.deleteTime,
                        folderType: v.folderType,
                        operateStatus: v.operateStatus,
                        updateTime: v.updateTime,
                        children: v.children,
                    };
                });
                this.options.push({
                    children: data,
                    folderId: '0',
                    name: '开放平台',
                });
            });
        },
        beforeUpload(v) {
            const that = this;
            if (!/jpg|png|jpeg/g.test(v.type)) {
                this.$message.warning('请选择jpg和png格式图片');
                return;
            }
            if (that.urls.length === this.textData.max) {
                that.$message.warning(`上传的图片不能超过${this.textData.max}张`);
                return;
            }
            //1MB=1024*1024(1MB=1024KB 1KB=1024MB)
            if (this.textData.type === 'main') {
                const is1M = v.size / 1024 / 1024 < 1;
                //限制文件上传大小
                if (!is1M) {
                    this.$message.error('上传图片大小不能超过 1MB!');
                    return;
                }
            }

            this.$ajax

                .post(base + 'oss/api/oss/getsign', {
                    ossDir: this.ossDir,
                })

                .then((res) => {
                    const resdata = res.Data;

                    const fromData = new FormData();

                    const fussix = v.name.split('.')[v.name.split('.').length - 1];

                    fromData.append('Filename', resdata.filename);

                    fromData.append('key', resdata.dir + resdata.filename + '.' + fussix);

                    fromData.append('policy', resdata.policy);

                    fromData.append('OSSAccessKeyId', resdata.accessid);

                    fromData.append('success_action_status', '200');

                    fromData.append('signature', resdata.signature);

                    fromData.append('callback', resdata.callback);

                    fromData.append('host', resdata.host);

                    fromData.append('file', v);

                    axios

                        .post('//oss.fjdaze.com/', fromData)

                        .then((res) => {
                            if (that.urls.length == this.textData.max) {
                                that.$message.warning(`上传的图片不能超过${this.textData.max}张`);

                                return;
                            }

                            if (res.data.Success) {
                                that.$refs.upload1.uploadFiles;

                                // that.urls.push(ossImg + res.data.Data);

                                if (that.urls.length < this.textData.max) {
                                    that.urls.push({
                                        url: ossImg + res.data.Data,

                                        fileExtension: '.' + fussix,

                                        name: v.name,
                                    });
                                }
                            } else {
                                that.$message.error(res.data.Tips);
                            }
                        })

                        .catch(() => {
                            this.$message.error('网络连接错误');
                        });

                    // this.$refs.upload.clearFiles();
                });
        },

        //删除

        del(index) {
            this.urls.splice(index, 1);
        },

        //确 定

        determine() {
            if (!this.directoryId) {
                this.$message.warning('请选择上传至');

                return;
            }

            if (this.urls.length == 0) {
                this.$message.warning('请上传图片');

                return;
            }

            this.loading = true;

            let ajaxData = {
                urls: this.urls.map((v) => {
                    return {
                        url: v.url,

                        fileExtension: v.fileExtension,
                    };
                }),

                folderId: this.directoryId,
            };

            this.$ajax

                .post('/api/tiktok/Material/BatchUploadImageSync', ajaxData)

                .then((res) => {
                    this.loading = false;

                    if (res.code === 200) {
                        this.materialIdList = res.result;

                        this.$message.success('上传成功');

                        this.dialogVisible = false;

                        this.$emit('uploadSuccess', this.materialIdList, this.textData.type);

                        this.searchMaterial(this.materialIdList);
                    }
                })

                .catch(() => {
                    this.loading = false;

                    this.$message.warning('操作失败');
                });
        },
        searchMaterial(ids) {
            this.searchTime++;
            this.$ajax
                .post('/api/tiktok/Material/SearchMaterial', {
                    materialIdList: ids,
                })
                .then((res) => {
                    if (res.code === 200) {
                        let list = res.result.materialInfoList;
                        const success = list.filter((el) => el.byteUrl);
                        const failed = list.filter((el) => !el.byteUrl);
                        if (!list.length && this.searchTime < 5) {
                            setTimeout(() => {
                                this.searchMaterial(ids);
                            }, 500);
                        }
                        if (success.length) {
                            this.textData.cb && this.textData.cb(success.map((el) => el.byteUrl));
                        }
                        if (failed.length && this.searchTime < 5) {
                            setTimeout(() => {
                                this.searchMaterial(failed.map((el) => el.materialId));
                            }, 500);
                        }
                    }
                });
        },
        uploadSectionFile() {},

        handleClose() {
            this.dialogVisible = false;
        },

        handleClick(val) {
            this.typeStatus = val;
        },

        confirmSuccess(list) {
            this.dialogVisible = false;

            this.textData.callback && this.textData.callback(list, this.textData.type);
            this.textData.cb && this.textData.cb(list.map((el) => el.byteUrl));
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    left: 50%;

    top: 50%;

    transform: translate(-50%, -50%);

    margin: 0px !important;
}

::v-deep .el-dialog__body {
    padding: 0 20px 10px;

    max-height: unset !important;
}

::v-deep .el-dialog .el-dialog--scroll {
    max-height: unset !important;

    overflow: hidden;

    padding: 0 !important;

    margin: 0 !important;
}

::v-deep .el-scrollbar__thumb {
    height: 0 !important;
}

.status {
    margin-top: 12px;

    height: 44px;

    background: #f2f2f2;

    width: 100%;

    > div {
        position: relative;

        line-height: 44px;

        padding: 0 30px;

        cursor: pointer;

        font-size: 14px;

        &::after {
            content: '';

            width: 1px;

            height: 19px;

            background: #e6e6e6;

            position: absolute;

            right: 0;

            top: 14px;
        }

        &:last-child {
            &::after {
                background: #f2f2f2;
            }
        }
    }

    .status-active1 {
        background: #fff;

        color: #ff5e27;

        &::before {
            content: '';

            width: 100%;

            height: 2px;

            background: #ff5e27;

            position: absolute;

            top: 0;

            left: 0;
        }

        &::after {
            background: #fff;
        }
    }
}

.title {
    display: flex;

    justify-content: flex-end;

    .label-title {
        width: 50px;
    }
}

.upload-box {
    display: flex;

    flex-direction: column;

    align-items: center;
}

.img-box {
    padding: 10px 10px 0 0;

    max-height: 200px;

    overflow-y: auto;
}
</style>
